import {DimensionValue, StyleSheet} from 'react-native';

import {TAB_BAR_HEIGH} from '/component/layout/TabLayout/TabLayout.style';
import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';
import {grayscale, greyf7, white} from '/theme/color/on.color';
import {alto, denim} from '/theme/color/secondary.color';
const VIEWPORT_HEIGHT: DimensionValue =
  `calc(100vh - ${TAB_BAR_HEIGH}px)` as DimensionValue;

export const styles = StyleSheet.create({
  container: {
    /* flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center', */
    flex: 1,
    height: VIEWPORT_HEIGHT,
    maxHeight: VIEWPORT_HEIGHT,
    overflow: 'hidden' as const,
    display: 'flex' as const,
    flexDirection: 'column' as const,
  },
  base: {
    backgroundColor: white,
    width: '100%',
  },
  modalHeaderBase: {
    flex: 0,
    flexShrink: 0,
    height: 'auto' as const,
    minHeight: 112,
  },
  scrollViewContainer: {
    maxHeight: 150,
    backgroundColor: white,
  },
  headerText: {
    fontSize: 16,
    marginLeft: 10,
  },
  buttonWidth: {
    flex: 1,
    alignItems: 'center',
    marginBottom: 4,
  },
  buttonFlex: {flex: 1},
  buttonFilter: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 34,
    backgroundColor: white,
    borderWidth: 1,
    borderColor: alto,
    marginLeft: 8,
    paddingVertical: indent * 0.1,
    paddingHorizontal: indent * 0.8,
    borderRadius: indent * 0.4,
    marginBottom: 4,
  },
  viewContainer: {
    flexDirection: 'row',
    paddingRight: 15,
    backgroundColor: white,
  },
  filtersButtonContainer: {
    marginTop: 0,
    width: '100%' as const,
    paddingHorizontal: 8,
  },
  // For wrapping tags container
  filtersWrap: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingLeft: 20,
    marginBottom: 5,
  },
  filterValText: {
    fontSize: 14,
    marginVertical: 8,
  },
  filterMoreText: {
    fontSize: 14,
    color: denim,
    marginTop: 8,
    marginLeft: 5,
  },
  SearchIcon: {
    fontSize: 22,
    color: grayscale,
  },
  iconReport: {
    fontSize: 17,
    width: 18,
    height: 18,
    paddingTop: 8,
  },
  tabBar: {
    flexDirection: 'row',
    backgroundColor: greyf7,
    borderRadius: 40,
    padding: 0,
    marginHorizontal: 16,
    marginBottom: 0,
    justifyContent: 'center',
  },
  tabItem: {
    flex: 1,
    alignItems: 'center',
    paddingVertical: 8,
    borderRadius: 40,
    backgroundColor: 'transparent',
  },
  activeTab: {
    backgroundColor: white,
    borderColor: alto,
    borderWidth: 1,
  },
  text: {
    marginLeft: indent * 0.4,
    fontSize: 14,
    maxWidth: 150,
  },
  buttonFilterActive: {
    backgroundColor: denim,
  },
  filterTextWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  filterDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: white,
    marginLeft: 6,
    marginTop: 2,
  },
  iconActive: {
    color: white,
  },
  textActive: {
    color: white,
  },
  clearFilterRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 2,
    paddingHorizontal: 12,
  },
  reportWrapper: {
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
    backgroundColor: white,
  },
  reportWrapperList: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden' as const,
    width: '100%' as const,
    maxWidth: MAX_CONTENT_WIDTH as number,
    alignSelf: 'center' as const,
    backgroundColor: white,
  },
});
